////////////////
// Imports
////////////////
import modular from 'modujs';

import globals from './globals';
import * as modules from './modules';

import { html } from "./utils/environment";
import { fontsLoader } from './utils/fontsLoader';
import { preloadImages } from "./utils/image";
import { styleSheetsLoader } from './utils/styleSheetsLoader';
import debounce from "./utils/debounce";
import isMobile from "./utils/isMobile";


////////////////
// Settings
////////////////
// Fonts
const fonts = [
    { name: "Altform", style: 'normal', weight: '400' },
    { name: "Altform", style: 'normal', weight: '500' },
    { name: "Editorial New", style: 'normal', weight: '400' },
    { name: "Editorial New", style: 'italic', weight: '400' },
    { name: "Editorial New", style: 'normal', weight: '300' },
    { name: "Editorial New", style: 'italic', weight: '300' }
]

// Modules
const app = new modular({
    modules: modules
});

// Mobile
const isMobileObj = isMobile()
const IS_TOUCH_DEVICE = isMobileObj?.phone || isMobileObj?.tablet
export default IS_TOUCH_DEVICE;

//debug
const isDebug = html.dataset.debug || false
window.isDebug = isDebug;


////////////////
// Hooks
////////////////
const onFontsLoaded = () => {
    html.classList.add("is-fonts-loaded");
}

const onImagesPreloaded = () => {
    html.classList.add("is-images-preloaded");
}

const onAllAssetsLoaded = () => {
    setTimeout(() => {
        html.classList.add('is-loaded');
        html.classList.add('is-first-loaded');
        html.classList.remove('is-loading');

        setTimeout(() => {
            html.classList.add('is-ready');
            html.classList.add('is-init');
        }, 400);

        setTimeout(() => {
            window.dispatchEvent(new Event('resize'));
        }, 10);

    }, 400);
}

////////////////
// Init
////////////////
function init() {
    // current template
    window.currentTemplate = html.dataset?.template

    // Load fonts
    window.isFontsLoaded = false;

    let fontsPromise = new Promise((resolve) => {
        fontsLoader(fonts,
            () => {
                // Callback
                onFontsLoaded?.()
                // Update modules
                requestAnimationFrame(() => {
                    const fontsLoadedEvent = new CustomEvent("fontsLoaded");
                    window.dispatchEvent(fontsLoadedEvent);
                    window.isFontsLoaded = true;
                })
                // Resolve
                resolve()
            }
        );
    })

    // Images
    let imagesPromise = new Promise((resolve) => {
        preloadImages(() => {
            // Callback
            onImagesPreloaded?.()
            // Resolve
            resolve()
        })
    })

    // When all assets are ready
    Promise.all([fontsPromise, imagesPromise]).then(() => {
        // Callback
        onAllAssetsLoaded?.()
    })

    // Bind global events
    bindEvents();

    // Check mobile state
    if (IS_TOUCH_DEVICE) {
        html.classList.add('is-touchable')
    }

    // First resize
    onResize();
    document.documentElement.style.setProperty("--vh-initial", `${document.documentElement.clientHeight * 0.01}px`);
    const headerCta = document.querySelector('.js-header-cta');
    if (headerCta) {
        const headerCtaWidth = headerCta.offsetWidth;
        const headerCtaHeight = headerCta.offsetHeight;
        document.documentElement.style.setProperty("--header-cta-width", `${headerCtaWidth}px`);
        document.documentElement.style.setProperty("--header-cta-height", `${headerCtaHeight}px`);
    }

    // Globals
    globals();

    // Init modules
    app.init(app);

    // Debug focus
    if(isDebug) {
        document.addEventListener('focusin', function() {
            console.log('focused: ', document.activeElement)
        }, true);
    }
}

////////////////
// Global events
////////////////
function bindEvents() {
    // Resize event
    const resizeEndEvent = new CustomEvent("resizeEnd");
    window.addEventListener("resize", debounce(
        () => {
            onResize();
            window.dispatchEvent(resizeEndEvent);
        }, 200, false)
    );
}

function onResize() {
    let vw = html.offsetWidth * 0.01;
    let vh = document.documentElement.clientHeight * 0.01;
    document.documentElement.style.setProperty("--vw", `${vw}px`);
    document.documentElement.style.setProperty("--vh", `${vh}px`);
    const headerCta = document.querySelector('.js-header-cta');
    if (headerCta) {
        const headerCtaWidth = headerCta.offsetWidth;
        const headerCtaHeight = headerCta.offsetHeight;
        document.documentElement.style.setProperty("--header-cta-width", `${headerCtaWidth}px`);
        document.documentElement.style.setProperty("--header-cta-height", `${headerCtaHeight}px`);
    }
}

////////////////
// Execute
////////////////
window.onload = (event) => {
    html.classList.remove("no-js");

    const $style = document.getElementById("stylesheet_main-css");

    if ($style) {
        styleSheetsLoader([$style], () => {
            init()
        })
    } else {
        console.warn('The "stylesheet_main-css" stylesheet not found');
    }
};
